var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2425.67 589.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #5cb5ff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 267.66,
    y1: 313.08,
    x2: 257.34,
    y2: 378.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0029ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#5cb5ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m172.42,343.15H20.02c-13.88,0-23.54-13.8-18.79-26.84L111.56,13.16c2.88-7.9,10.39-13.16,18.79-13.16h138.4c13.88,0,23.54,13.8,18.79,26.84l-115.13,316.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m353.4,343.15l-84.81,233.01c-2.88,7.9-10.39,13.16-18.79,13.16H111.39c-13.88,0-23.54-13.8-18.79-26.84l79.83-219.33h180.97Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "353.39 343.15 207.72 246.17 172.42 343.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "172.42 343.15 332.2 401.36 353.39 343.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m663.65,306.31c-10.43-9.46-26.02-17.47-46.57-23.89l-58.34-18.56c-10.61-3.15-18.44-6.97-23.23-11.46-4.79-4.49-7.34-10.13-7.34-16.92,0-8.61,4.37-16.07,12.8-22.38,8.43-6.31,19.22-9.46,32.32-9.46,15.1,0,28.38,3.33,39.78,10.13,7.7,4.55,14.01,10.07,18.98,16.56h40.93c-7.34-16.92-19.77-30.99-37.36-42.27-17.53-11.28-38.45-16.92-62.64-16.92s-43.12,6.49-58.7,19.22c-15.59,12.8-23.41,28.2-23.41,46.09,0,27.71,17.77,47.12,53.43,58.22l59.67,19.1c13.58,4.31,23.23,9.1,29.05,14.55,5.76,5.46,8.61,12.13,8.61,20.07,0,9.76-5.15,18.44-15.28,25.89-10.13,7.46-23.04,11.28-38.81,11.28-17.89,0-33.29-4.67-46.39-13.95-9.82-6.97-17.47-15.4-22.98-25.23h-39.72c6.79,20.25,19.77,37.3,38.81,51.06,19.04,13.77,41.78,20.74,68.34,20.74l.97-.18c27.35,0,49.73-6.91,67.01-20.86,17.22-13.95,25.83-30.99,25.83-51.43,0-16.92-5.28-30.02-15.77-39.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m919.56,175.8l-82.96,119.53-83.2-119.53h-35.36v237.78h37.17v-173.98l81.08,114.25,81.57-114.25v173.98h36.99v-237.78h-35.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1122.47,175.8h-47.06l-94.18,237.78h38.45l22.74-57.73h113.1l22.68,57.73h38.51l-94.24-237.78Zm-67.43,147.36l44.09-112.37,43.78,112.37h-87.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1379.05,322.19c17.41-4.49,30.99-13.4,40.75-26.87,9.82-13.4,14.62-28.2,14.62-44.45,0-19.71-7.16-37.11-21.22-52.4-14.13-15.22-32.99-22.86-56.7-22.86h-113.1v237.78h36.81v-88.23h60.04l57.67,88.42h42.45l-61.31-91.39Zm-99.21-29.84l.36-83.75h75.26c12.98,0,23.41,4.12,31.35,12.43,7.94,8.31,11.95,18.25,11.95,29.65s-4.12,21.22-12.25,29.35c-8.13,8.13-18.92,12.31-32.38,12.31h-74.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1541.21,246.09v167.49h36.99v-204.49l-36.99,36.99Zm-83.93-70.29v33.29h204.49v-33.29h-204.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1852.59,175.98v99.94h-123.53v-99.94h-37.11v237.78h37.11v-104.67h160.22v-133.11h-36.69Zm0,169.8v67.98h36.69v-104.61l-36.69,36.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1936.71,175.98v237.78h37.48v-237.78h-37.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2157.57,322.38c17.4-4.49,30.99-13.4,40.81-26.87,9.76-13.4,14.55-28.2,14.55-44.45,0-19.71-7.1-37.11-21.22-52.4-14.07-15.22-32.99-22.86-56.7-22.86h-113.1v237.78h36.81v-88.23h60.04l57.73,88.42h42.45l-61.37-91.39Zm-99.15-29.84l.3-83.75h75.32c12.92,0,23.35,4.12,31.35,12.43,7.94,8.31,11.89,18.25,11.89,29.72s-4.12,21.22-12.25,29.29c-8.13,8.13-18.92,12.31-32.32,12.31h-74.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2425.67,209.28v-33.29h-171.26v237.78h170.95v-33.66h-134.63v-71.32h117.53v-31.84h-117.53v-67.68h134.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo_.438253bd42130b75060412d80a7b11a6.svg";
export { ForwardRef as ReactComponent };